module.exports = __webpack_public_path__ + "img/toumingmozhenxing.min.fc6508bc.png";